import React from 'react'
import Layout from '../components/Layout'
import RichText from '../components/RichText'
import TeamMember from '../components/TeamMember'

function SectionTitle({ children, color = 'brand-light' }) {
  return (
    <div className="flex items-center mb-6">
      <h2 className={`text-${color} font-bold uppercase text-xl font-heading`}>{children}</h2>
      <hr className={`flex-1 ml-4 border-0 h-[1px] bg-${color}`} />
    </div>
  )
}

function TeamSection({ title, members }) {
  return (
    <div className="mb-8">
      <h4 className="text-brand-dark font-bold mb-4">{title}</h4>
      <div className="flex flex-wrap gap-4">
        {members.map((member, index) => (
          <TeamMember key={index} {...member} />
        ))}
      </div>
    </div>
  )
}

export default function Sobre({
  title,
  sobreContent,
  researchImage,
  pesquisaTitle,
  pesquisaContent,
  equipeIntro,
  teamImage,
  parceriaTitle,
  parceriaContent,
  partnershipImage,
  professores = [],
  pesquisadores = [],
  posGraduandos = [],
  graduandos = [],
  egressos = []
}) {
  return (
    <Layout fullWidth>
      {/* SOBRE Section */}
      <div className="bg-brand-bg py-8">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <img src={researchImage} alt="Pesquisa" className="w-full h-auto rounded" />
            </div>
            <div>
              <SectionTitle>{title}</SectionTitle>
              <RichText content={sobreContent} className="text-brand-dark text-justify space-y-4" />
            </div>
          </div>
        </div>
      </div>

      {/* PESQUISA Section */}
      <div id="pesquisa" className="bg-brand-dark text-white py-8">
        <div className="container mx-auto px-4">
          <h3 className="text-2xl font-bold mb-6 font-heading">{pesquisaTitle}</h3>
          <RichText
            content={pesquisaContent}
            className="text-justify prose-a:text-brand-lighter prose-a:no-underline hover:prose-a:underline"
            invert
            columns
          />
        </div>
      </div>

      {/* EQUIPE Section */}
      <div id="equipe" className="bg-brand-bg py-8">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            <div>
              <SectionTitle>Equipe</SectionTitle>
              <RichText content={equipeIntro} className="text-brand-dark text-justify" />
            </div>
            <div>
              <img src={teamImage} alt="Equipe" className="w-full h-auto max-w-[780px]" />
            </div>
          </div>

          <div className="flex items-center mb-6">
            <h3 className="text-brand-light font-bold uppercase text-lg font-heading">Equipe Atual</h3>
            <hr className="flex-1 ml-4 border-0 h-[1px] bg-brand-light" />
          </div>

          <TeamSection title="Professores" members={professores} />
          <TeamSection title="Pesquisadores" members={pesquisadores} />
          <TeamSection title="Pós-graduandos" members={posGraduandos} />
          <TeamSection title="Graduandos" members={graduandos} />

          {egressos.length > 0 && (
            <TeamSection title="Professores e Pesquisadores Egressos" members={egressos} />
          )}
        </div>
      </div>

      {/* PARCERIA Section */}
      <div id="parceria" className="bg-brand-bg py-8">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <img src={partnershipImage} alt="Parcerias" className="w-full h-auto" />
            </div>
            <div className="pt-8">
              <div className="flex items-center mb-6">
                <h2 className="text-[#4A96D2] font-bold uppercase text-xl font-heading">{parceriaTitle}</h2>
                <hr className="flex-1 ml-4 border-0 h-[1px] bg-[#4A96D2]" />
              </div>
              <RichText content={parceriaContent} className="text-justify" />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
